export const CATEGORY_ICONS = {
  Management: 6,
  "Information Technology": 1,
  "Arts & Humanities": 2,
  Commerce: 3,
  "Media & Journalism": 4,
  "Amity Future Academy": 1,
  Science: 5,
  "Amity PROx": 5,
  "Free Courses": 5,
};

export const PROGRAM_DROPDOWN_LP = [
  {
    title: "BACHELOR OF BUSINESS ADMINISTRATION",
    programType: "UG",
    id: "240",
  },
  {
    title: "BACHELOR OF COMPUTER APPLICATIONS",
    programType: "UG",
    id: "241",
  },
  {
    title: "MASTER OF BUSINESS ADMINISTRATION",
    programType: "PG",
    id: "440",
  },
  {
    programType: "PG",
    title: "MASTER OF COMPUTER APPLICATIONS",
    id: "515",
  },
];

export const DEGREE_TYPES = {
  UG: { id: "UG_Program", name: "UNDER GRADUATE" },
  PG: { id: "PG_Program", name: "POST GRADUATE" },
};

export const PROGRAM_DROPDOWN = [
  {
    title: "BACHELOR OF COMPUTER APPLICATIONS",
    programType: "UG",
    id: "241",
  },
  {
    programType: "UG",
    title: "BCA WITH SPECIALISATION IN DATA ENGINEERING",
    id: "241",
  },
  {
    programType: "UG",
    title: "BCA WITH SPECIALISATION IN SOFTWARE ENGINEERING",
    id: "241",
  },
  {
    title: "BACHELOR OF BUSINESS ADMINISTRATION",
    programType: "UG",
    id: "240",
  },
  {
    programType: "UG",
    title: "BBA WITH SPECIALISATION IN DATA ANALYTICS",
    id: "240",
  },
  {
    title: "BACHELOR OF COMMERCE",
    programType: "UG",
    id: "243",
  },
  {
    title: "BACHELOR OF ARTS (JOURNALISM AND MASS COMMUNICATION)",
    programType: "UG",
    id: "242",
  },
  { programType: "UG", title: "BACHELOR OF ARTS", id: "244" },
  { programType: "UG", title: "BACHELOR OF ARTS (HINDI MEDIUM)", id: "492" },
  {
    programType: "UG",
    title: "BACHELOR OF ARTS (GENERAL) HINDI MEDIUM",
    id: "492",
  },
  {
    programType: "UG",
    title: "BACHELOR OF ARTS (GENERAL) IN TELUGU",
    id: "599",
  },
  {
    programType: "UG",
    title: "BACHELOR OF ARTS (GENERAL) IN TAMIL",
    id: "598",
  },
  {
    programType: "UG",
    title: "BACHELOR OF ARTS (GENERAL) IN MALAYALAM",
    id: "601",
  },
  {
    programType: "UG",
    title: "BACHELOR OF ARTS (GENERAL) IN KANNADA",
    id: "600",
  },
  {
    programType: "UG",
    title: "BACHELOR OF COMMERCE (GENERAL) HINDI MEDIUM",
    id: "491",
  },
  { programType: "PG", title: "MASTER OF BUSINESS ADMINISTRATION", id: "440" },
  {
    programType: "PG",
    title: "MASTER OF COMMERCE (FINANCIAL MANAGEMENT)",
    id: "245",
  },
  {
    programType: "PG",
    title: "MASTER OF ARTS (JOURNALISM AND MASS COMMUNICATION)",
    id: "246",
  },
  { programType: "PG", title: "MASTER OF COMPUTER APPLICATIONS", id: "515" },
  {
    programType: "PG",
    title: "MASTER OF ARTS (PUBLIC POLICY & GOVERNANCE)",
    id: "608",
  },
  {
    programType: "PG",
    title: "MCA WITH SPECIALISATION IN CYBER SECURITY",
    id: "515",
  },
  {
    programType: "PG",
    title: "MCA WITH SPECIALISATION IN SOFTWARE ENGINEERING",
    id: "515",
  },
  {
    programType: "UG",
    title: "BACHELOR OF COMMERCE (HONOURS)",
    id: "612",
  },
  {
    programType: "PG",
    title: "MASTER OF SCIENCE IN DATA SCIENCE",
    id: "613",
  },
];
